import Ch7Ecosystem from '@/chapters/Ch7Ecosystem';

export default function EcosystemPage() {
  return <Ch7Ecosystem />;
}
